import mixpanel from 'mixpanel-browser';

// Initialize Mixpanel
mixpanel.init(import.meta.env.VITE_MIX_PANEL_ID, {
  debug: import.meta.env.DEV,
  track_pageview: true,
  persistence: 'localStorage',
});

// Export a function to identify users
export const identify = (userId: string) => {
  mixpanel.identify(userId);
};

// Export a function to set user properties
export const setUserProperties = (properties: Record<string, any>) => {
  mixpanel.people.set(properties);
};

// Export a function to track events
export const track = (eventName: string, properties?: Record<string, any>) => {
  mixpanel.track(eventName, properties);
};

// Export the mixpanel instance in case it's needed directly
export default mixpanel;
